module.exports = __webpack_public_path__ + "static/media/2n.e2457ba6.jpg";